import './current-lesson.css';

import { observer, useViewModel } from '@descomplica/microfrontend-react';
import { LoadingSpinner } from '@descomplica/uee-ui-components';
import React from 'react';

import { ClassroomViewModel, Lesson, Video } from '../../classroom.vm';
import { CertificateContainer } from './certificate-container';
import { ExercisesContainer } from './exercises-container';
import { VideoProgress } from './player/player';
import { LivePlayerContainer, VideoPlayerContainer } from './player-container';

type Params = {
  currentVideo: Video | undefined;
  currentLesson?: Lesson;
  onClose: { (): void };
  onConfigProfile?: { (): void };
  onVideoProgress: { (videoProgress: VideoProgress): void };
};

export const CurrentLesson: React.FC<Params> = ({
  currentVideo,
  currentLesson,
  onVideoProgress,
  onClose,
}: Params) => {
  const vm = useViewModel(ClassroomViewModel);

  const handleVideoPlaying = async () => {
    await vm.handleVideoPlaying();
  };

  if (!vm.currentLesson)
    return (
      <div className="classroom-loading">
        <LoadingSpinner />
      </div>
    );

  if (vm.hasCertificateOpen) {
    return (
      <CertificateContainer
        title={'Certificado'}
        mobileSidebarOpen={vm.mobileSidebarOpen}
        onClose={() => vm.setHasCertificateOpen(false)}
      />
    );
  }

  if (vm.hasExerciseOpen) {
    return (
      <ExercisesContainer
        onClose={onClose}
        mobileSidebarOpen={vm.mobileSidebarOpen}
        title={vm.currentLesson?.name ?? ''}
        key={new Date().getSeconds()}
        showResult={vm.showResult}
        isLoadingExercise={vm.isLoadingExercise}
        vm={vm}
      />
    );
  }

  return currentLesson?.videos.length > 0 && !currentLesson?.streaming?.title ? (
    <VideoPlayerContainer
      title={currentVideo?.title}
      currentVideo={currentVideo}
      onVideoProgress={onVideoProgress}
      handleVideoPlaying={handleVideoPlaying}
      mobileSidebarOpen={vm.mobileSidebarOpen}
      onClose={onClose}
      showAutoplay={vm.hasHighestClassifierGuid}
      autoPlay={vm.autoPlayLessonEnabled}
    />
  ) : (
    <LivePlayerContainer
      onClose={onClose}
      mobileSidebarOpen={vm.mobileSidebarOpen}
      title={vm.currentLesson?.streaming?.title ?? ''}
      courseGuid={vm.classroom?.course.guid}
      streamingGuid={vm.currentLesson?.streaming.guid ?? ''}
    />
  );
};

export default observer(CurrentLesson);
